
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Ahmet Yılmaz',
      car: 'Audi A6',
      rating: 5,
      text: 'Motor rektifiye işlemi için geldim. Hem işçilik hem de müşteri ilgisi mükemmeldi. Aracım yeni gibi oldu.',
    },
    {
      name: 'Mehmet Demir',
      car: 'BMW 5 Serisi',
      rating: 5,
      text: 'Şanzıman tamiri için başvurdum. Detaylı bilgilendirme ve profesyonel yaklaşımları için teşekkür ederim.',
    },
    {
      name: 'Can Öztürk',
      car: 'Mercedes E-Class',
      rating: 5,
      text: 'DR.ECU yazılım hizmeti aldım. Performans artışı gerçekten hissediliyor. Kesinlikle tavsiye ederim.',
    },
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-3 sm:mb-4">
            Müşteri Yorumları
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-6 sm:p-8 border border-gray-200 hover:shadow-xl transition-all duration-300"
            >
              <div className="mb-4 sm:mb-6">
                <h4 className="font-sans text-base sm:text-lg font-semibold text-gray-900">
                  {testimonial.name}
                </h4>
                <p className="font-sans text-xs sm:text-sm text-gray-600">{testimonial.car}</p>
              </div>

              <div className="flex mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-gold text-base sm:text-lg"></i>
                ))}
              </div>

              <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}